import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@zurich-primitives/button';
import { Modal } from '@zurich-base-ui/components.modal';
import Warning from 'app/assets/Icons/Warning.svg';
import {
  getDisclaimerModal,
  useAppSelector,
  setDisclaimerModal,
  useAppDispatch
} from 'app/redux';
import styles from './Disclaimer.module.scss';
import config from 'config';

const Disclaimer: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isDisclaimer: boolean = useAppSelector(getDisclaimerModal);

  const goToGuidelines = (): void => {
    navigate(config.APP.PATH.LANDING);
  };

  return (
    <Modal
      on={isDisclaimer}
      onClose={() => dispatch(setDisclaimerModal(false))}
      variant="slim"
    >
      <div className={`${styles.modal} p-8 pt-6`}>
        <img src={Warning} alt="warning" className={styles.warning} />
        <h2 className="h1">Important information</h2>
        <p className="body-sm-r">
          Please select your business area and service type
          <br />
          before uploading the file
        </p>
        <p className="body-sm-r">
          <br />
          <Button
            variant="tertiary"
            onClick={goToGuidelines}
            className={`${styles['tos-btn']} body-sm-r mx-auto`}
            disabled
          >
            Visit our Guidelines to know more!
          </Button>
        </p>

        <div className={`${styles.modalButtons}`}>
          <Button
            onClick={() => dispatch(setDisclaimerModal(false))}
            className={styles['ok-btn']}
          >
            Ok
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Disclaimer;
